import React from 'react';
import styled from 'styled-components';
import { LoadingSpinner } from '@tw/tw-component-library';
import { COLORS } from '../Activities/ActivityMenu/styles/constants';

const IndicatorContainer = styled.div`
  padding: 0.75rem;
  background-color: ${COLORS.BACKGROUND};
  border-radius: 4px;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: ${COLORS.PRIMARY};
`;

type UploadProcessingIndicatorProps = {
  uploadingFileNames: string[];
  dataTour?: string;
};

export const UploadProcessingIndicator: React.FC<UploadProcessingIndicatorProps> = ({
  uploadingFileNames,
  dataTour,
}) => {
  if (uploadingFileNames.length === 0) return null;

  return (
    <IndicatorContainer data-tour={dataTour}>
      <LoadingSpinner size="small" />
      <span>
        Uploading {uploadingFileNames.length} file
        {uploadingFileNames.length !== 1 ? 's' : ''}... Waiting for files to be
        processed.
      </span>
    </IndicatorContainer>
  );
};

